import { render } from "./Breadcrumbs.vue?vue&type=template&id=f074495c&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=f074495c&lang=scss&scoped=true"
import "./Breadcrumbs.vue?vue&type=style&index=1&id=f074495c&lang=scss"
script.render = render
script.__scopeId = "data-v-f074495c"

export default script